import { apiAuthClient } from 'shared/api/lib/apiAuthClient';

import type { DeleteCustomizationsDocumentRequestType } from '../types';

export const deleteCustomizationsDocument = async ({
  pathParams: { organisationId },
}: DeleteCustomizationsDocumentRequestType) => {
  const url = `/api/v2/organisations/${organisationId}/customizations/document`;

  const { data } = await apiAuthClient.delete<{ data: '' }>(url);

  return data;
};
